import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import SelectMode from "./SelectMode";
import PrivateQuiz from "./components/PrivateQuiz";
import BusinessQuiz from "./components/BusinessQuiz";
import PersonalQuiz from "./components/PersonalQuiz";
import ResultPage from "./components/ResultPage";
import Footer from "./components/Footer";
import { Terms } from "./components/terms";
import { Privacy } from "./components/privacy-policy";



function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/" element={<SelectMode />} />
          <Route path="/private" element={<PrivateQuiz mode="private" />} />
          <Route path="/business" element={<BusinessQuiz mode="business" />} />
          <Route path="/personal" element={<PersonalQuiz mode="personal" />} />
          <Route path="/result/:main_genre" element={<ResultPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" />} /> {/* 不明なURLはトップへ */}
        </Routes>
        <Footer />
      </>
    </Router>
  );
}

export default App;
